export default class AreYouSureModal {
	constructor() {
		this.init();
	}

	init() {
		let AreYouSureModal = this;
		document.querySelectorAll('button[data-ays-link]:not([data-ays-init="1"])').forEach(function (button, key) {
			button.setAttribute('data-ays-init', "1");

			button.addEventListener('click', (e) => {
				AreYouSureModal.showModal(button);
			});
		});
	}

	showModal(button) {
		let titleIcon = button.getAttribute('data-ays-icon') ?? 'far fa-trash';
		let href = button.getAttribute('data-ays-link');
		let title = button.getAttribute('data-ays-title') ?? "Smazání položky";
		let content = button.getAttribute('data-ays-content') ?? "Jste si jisti že chcete smazat tuto položku?";
		let successButtonTitle = button.getAttribute('data-ays-success-title') ?? "Ano, smazat";
		let successButtonIcon = button.getAttribute('data-ays-success-icon') ?? "far fa-trash";
		let successButtonClass = button.getAttribute('data-ays-success-class') ?? "btn-success";
		let successButtonAttr = button.getAttribute('data-ays-success-attr') ?? false;
		let abortButtonTitle = button.getAttribute('data-ays-abort-title') ?? "Ne";
		let abortButtonIcon = button.getAttribute('data-ays-abort-icon') ?? "far fa-times";
		let abortButtonClass = button.getAttribute('data-ays-abort-class') ?? "btn-outline btn-outline-danger";
		let abortButtonAttr = button.getAttribute('data-ays-abort-attr') ?? false;
		let spinnerText = button.getAttribute('data-ays-spinner-text') ?? null;
		let token = button.getAttribute('data-ays-csrf-token');
		let formId = button.getAttribute('data-ays-csrf-formId');
		let hideSuccessButton = button.getAttribute('data-ays-success-hide') ?? false;

		let modal = document.getElementById('areYouSure');
		let body = modal.querySelector('.modal-body > span');
		let header = modal.querySelector('.modal-header > h3');
		let sButton = modal.querySelector('.modal-footer a');
		let aButton = modal.querySelector('.modal-footer button');
		let bootstrapModal = new bootstrap.Modal(modal, {});

		bootstrapModal.hide();

		header.innerHTML = '<i class="' + titleIcon + ' me-2"></i> ' + title;
		body.innerHTML = content;

		sButton.classList.remove('btn-outline-success', 'btn-success');
		sButton.classList.add(...successButtonClass.split(' '));
		sButton.setAttribute('href', href);
		sButton.innerHTML = '<i class="' + successButtonIcon + ' me-1"></i> ' + successButtonTitle;

		if (hideSuccessButton) {
			sButton.classList.add('d-none');
			sButton.parentNode.classList.remove('btn-group')
		} else if (!sButton.parentNode.classList.contains("btn-group")) {
			sButton.parentNode.classList.add('btn-group')
		}

		if (spinnerText) {
			sButton.setAttribute('data-spinner-text', spinnerText);
		}

		if (token) {
			sButton.setAttribute('href', 'javascript:;');

			sButton.addEventListener('click', () => {
				let form = $('#' + formId);

				if ($(form).length > 0) {
					$(form).remove();
				}

				let dForm = $('<form id="' + formId + '" action="' + href + '" class="ajax" method="post" novalidate="" data-naja-history="off"></form>');
				dForm.append('<input name="_token_" type="hidden" value="' + token + '">');
				$('body').append(dForm);
				naja.uiHandler.submitForm(document.getElementById(formId));
			});
		}

		if (successButtonAttr) {
			Array.prototype.forEach.call(JSON.parse(successButtonAttr), function (attr, val) {
				aButton.setAttribute(attr, val);
			});
		}

		aButton.classList.remove('btn-outline-danger', 'btn-danger');
		aButton.classList.add(...abortButtonClass.split(' '));
		aButton.innerHTML = '<i class="' + abortButtonIcon + ' me-1"></i> ' + abortButtonTitle;

		if (abortButtonAttr) {
			Array.prototype.forEach.call(JSON.parse(abortButtonAttr), function (attr, val) {
				aButton.setAttribute(attr, val);
			});
		}

		bootstrapModal.show();
	}
}

